import { render, staticRenderFns } from "./WizardMultiplo.vue?vue&type=template&id=b3c56936&"
import script from "./WizardMultiplo.vue?vue&type=script&lang=js&"
export * from "./WizardMultiplo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports